var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8843 6.54487C15.7683 6.42871 15.6304 6.33656 15.4787 6.27369C15.327 6.21083 15.1644 6.17847 15.0002 6.17847C14.8359 6.17847 14.6733 6.21083 14.5216 6.27369C14.3699 6.33656 14.2321 6.42871 14.116 6.54487L10.2943 10.3657C10.2162 10.4438 10.1102 10.4877 9.99975 10.4877C9.88927 10.4877 9.7833 10.4438 9.70517 10.3657L5.88433 6.54487C5.64995 6.31037 5.33201 6.17859 5.00046 6.17851C4.66891 6.17843 4.35091 6.31006 4.11642 6.54445C3.88192 6.77883 3.75014 7.09677 3.75006 7.42832C3.74998 7.75987 3.88162 8.07787 4.116 8.31237L7.93767 12.134C8.20851 12.4049 8.53005 12.6198 8.88394 12.7664C9.23782 12.913 9.61712 12.9884 10.0002 12.9884C10.3832 12.9884 10.7625 12.913 11.1164 12.7664C11.4703 12.6198 11.7918 12.4049 12.0627 12.134L15.8843 8.31237C16.1187 8.07796 16.2503 7.76007 16.2503 7.42862C16.2503 7.09716 16.1187 6.77928 15.8843 6.54487Z",
    fill: "#868E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.a9bacbe052ce80e16295de454a930d26.svg";
export { ForwardRef as ReactComponent };